// Home page component
import { Hero } from '../components/Hero';
import { Sections } from '../components/Sections';

export function HomePage() {
  return (
    <>
      <Hero />
      <Sections />
    </>
  );
}

